module.exports = __webpack_public_path__ + "static/media/img11.218101d5.png";